import axios from 'axios';
import config from './config';

const API_BASE_URL = config.API_BASE_URL;

export const getUserLocations = async (userId) => {
  const response = await axios.get(`${API_BASE_URL}/UserLocations/${userId}`);
  return response.data;
};

export const addUserLocation = async (location) => {
  const response = await axios.post(`${API_BASE_URL}/UserLocations`, location);
  return response.data;
};

export const updateUserLocation = async (id, location) => {
  const response = await axios.put(`${API_BASE_URL}/UserLocations/${id}`, location);
  return response.data;
};

export const deleteUserLocation = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/UserLocations/${id}`);
  return response.data;
};

export const setDefaultLocation = async (id) => {
  const response = await axios.put(`${API_BASE_URL}/UserLocations/${id}/setdefault`);
  return response.data;
};
